<template>
  <div class="bankrecharge_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ data.payment.bank }}
      </div>
    </div>
    <div class="bank_detail">
      <div class="item">
        <p class="info">
          {{ $t('invest_qrcode.amount') }}
          <span>{{ utils_moneyMark() }}{{ money }}</span>
          <span>{{ actualAmount }}</span>
        </p>
      </div>
      <div class="item">
        <p class="info">
          {{ $t('invest_bank.name') }}
          <span>{{ data.payment.username }}</span>
        </p>
        <div
          v-clipboard="() => data.payment.username "
          v-clipboard:success="copy"
          class="copy_btn"
        >
          {{ $t('invest_bank.copy') }}
        </div>
      </div>
      <div class="item">
        <p class="info">
          {{ $t('invest_bank.account') }}
          <span>{{ data.payment.account }}</span>
        </p>
        <div
          v-clipboard="() => data.payment.account "
          v-clipboard:success="copy"
          class="copy_btn"
        >
          {{ $t('invest_bank.copy') }}
        </div>
      </div>
      <div class="item">
        <p class="info">
          {{ $t('invest_bank.bank') }}
          <span>{{ data.payment.bank }}</span>
        </p>
        <div
          v-clipboard="() => data.payment.bank "
          v-clipboard:success="copy"
          class="copy_btn"
        >
          {{ $t('invest_bank.copy') }}
        </div>
      </div>
      <!-- <div class="item">
				<p class="info">付款人：<input type="text" v-model.trim="pay_user" placeholder="请输入付款人"></p>
			</div>
			<div class="item">
				<p class="info">附言：<input type="text" v-model.trim="pay_remark" placeholder="请输入充值附言"></p>
			</div> -->
    </div>
    <div
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('utils.submit') }}
    </div>
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Button
	} from "vant";
	import Fetch from "../../utils/fetch";
	import Clipboard from "v-clipboard";

	Vue.use(Button).use(Clipboard);

	export default {
		name: "InvestBank",
		data() {
			return {
				data: {},
				pay_user: '',
				pay_remark: '',
				money: 0,
				actualAmount:'',
			};
		},
		created() {
			this.$parent.footer("user", false);
		},
		mounted() {
			this.money = this.$route.query.money ? this.$route.query.money : "";
			this.start();
		},
		methods: {
			copy() {
				this.$toast({
					background: "#07c160",
					message: this.$t('invest_qrcode.copySucceeded'),
				});
			},
			start() {
				Fetch("/user/recharge_type", {
					money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
				}).then((r) => {
					this.data = r.data;
					this.changeAmount();
				});
			},
			submitBtn() {
				Fetch("/user/recharge_apply", {
					id: this.data.orderId
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				});
			},
			changeAmount() {
				var num = 2;
				if (this.data.payment.type == 1) {
					if (this.data.payment.rate > 10000) {
						num = 8;
					} else if (this.data.payment.rate > 1000) {
						num = 6;
					} else if (this.data.payment.rate > 10) {
						num = 4;
					}
					this.actualAmount = "(≈" + (this.money / this.data.payment.rate).toFixed(num) + this.data.payment.mark+")";
				} else {
					this.actualAmount = "(≈" + this.data.payment.mark + (this.money / this.data.payment.rate).toFixed(num)+")";
				}
			}
		},
	};
</script>

<style lang="less" scoped>
	.bankrecharge_wrap {
		background: #fff !important;
		width: 100%;
		min-height: 100vh;
		padding-bottom: 88px;
		position: relative;
		color: #16223a;
		box-sizing: border-box;
	}
	.red_top_bg{
		background: #fff;
		border-bottom: 1px solid #f0f2f5;
	}
	.bank_detail {
		width: auto;
		margin: 16px 16px 0;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0 12px 22px rgba(22, 34, 58, 0.08);
		border: 1px solid rgba(255, 93, 122, 0.16);
		border-radius: 14px;
		padding: 14px 16px;
		font-size: 14px;
		box-sizing: border-box;

		.item {
			min-height: 56px;
			height: auto;
			border-bottom: 1px solid #f0f2f5;
			line-height: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			gap: 12px;

			.info {
				font-weight: bold;
				color: #16223a;
				min-width: 0;
				flex: 1;
				span:nth-child(1){
					font-weight: initial;
				}
				span:nth-child(2){
					color: #6d7688;
					font-size: 14px;
				}
			}

			.copy_btn {
				color: #ff5d7a;
				font-size: 12px;
				flex: 0 0 auto;
				padding: 5px 10px;
				border-radius: 8px;
				background: #fff0f4;
				font-weight: 700;
			}
		}
	}

	.warming {
		margin-top: 17px;
		padding: 0 14px;

		.tit {
			font-size: 14px;
			color: rgba(0, 0, 0, .8);
			line-height: 20px;
			font-weight: bold;
		}

		.content {
			font-size: 12px;
			color: rgba(0, 0, 0, .6);
			line-height: 17px;
			margin-top: 9px;
		}
	}

	.basic_btn {
		width: calc(100% - 32px);
		height: 44px;
		margin: 24px 16px 0;
		border-radius: 10px;
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%) !important;
		color: #fff;
		font-size: 14px;
		font-weight: 700;
		line-height: 44px;
	}

	@media screen and (max-width: 374px) {
		.bank_detail {
			margin-right: 12px;
			margin-left: 12px;
			padding-right: 12px;
			padding-left: 12px;
		}

		.basic_btn {
			width: calc(100% - 24px);
			margin-right: 12px;
			margin-left: 12px;
		}
	}
</style>
